/* eslint-disable eqeqeq */

// 1 => active
// 2 => not active

export const adminStatusValues = {
  active: 1,
  notActive: 2
};

export const getAdminStatusArr = (t) => {
  return [
    {
      id: 1,
      name: 'مفعل',
      value: adminStatusValues?.active
    },
    {
      id: 2,
      name: 'غير مفعل',
      value: adminStatusValues?.notActive
    }
  ];
};
